import forEach from "lodash/forEach";
import sanitizer from 'sanitizer';
import {AxiomEmoji, ActionsEmoji, InsightEmoji, DefaultEmoji, thumbsDownEmoji, thumbsUpEmoji} from '../commenting_widget/icon_components/Reactions';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict';
import format from 'date-fns/format';

function formatAMPM (date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; //  12 % 12 = 0, 0 % 12 = 0 => the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}

// convert "DD/MM/YYYY" to standard format
function dateFormat(ddMMyy) {
  return new Date(ddMMyy.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3"));
}

function stringToBase64(string) {
  return btoa(encodeURIComponent(string));
}

function getParams(key = '', url = window.location.search) {
  const searchParams = new URLSearchParams(url);
  if(searchParams.has(key)) return searchParams.get(key);
  return false;
}

function actionCountLabel(count, label){
  var actionLabel = count > 1 ? `${count} ${label}s`: `${count} ${label}`;
  return actionLabel;
}

function isUrl(string = '') {
  const URL_REGEX = new RegExp("^(https?:\/\/)|www+([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$", "i");
  return string.match(URL_REGEX) !== null;
}

function getHost(storyPageUrl) {
  const urlObject = new URL(storyPageUrl);
  return urlObject.hostname;
}

function getParameterFromUrl(inputKey = '') {
  const windowLocationElements = window.location.href.split('&');
  const urlParam = windowLocationElements.find( urlItem => urlItem.indexOf(inputKey) > -1);
  return urlParam ? urlParam.split('=').splice(-1).pop() : '';
}

function getAttributeName(event, parentClassName) {
  const targetAttribute = event.target.getAttribute('name'),
        footerMenuAttribute = event.target.closest(`.${parentClassName}`) ? event.target.closest('.'+ parentClassName +'').getAttribute('name') : false;
  const attributeName = targetAttribute || footerMenuAttribute;
  return attributeName;
}

function setImageSearchParams(url, searchParams={}) {
  if(url){
    const urlobj = new URL(url);
    forEach(searchParams,(value, key)=> {
      urlobj.searchParams.set(key, value);
    });
    return urlobj.href;
  }
}

function humanizeDate(timestamp, pageType = '') {
  const dateInWords = distanceInWordsStrict(timestamp, new Date())
  return formatTimeStamp(dateInWords, timestamp);
}

function formatTimeStamp(dateInWords, timestamp) {
  let relativeTime = "";
  if(dateInWords.includes("seconds")) {
    relativeTime = "Just Now";
  } else if(dateInWords.includes("1 minute")) {
    relativeTime = dateInWords.replace("minute", "min ago");
  } else if(dateInWords.includes("minutes")) {
    relativeTime = dateInWords.replace("minutes", "mins ago");
  } else if(dateInWords.includes("hours") && (new Date(timestamp).getDate() === new Date().getDate())) {
    relativeTime = `Today at ${format(timestamp, 'h:mm A')}`
  } else if( (dateInWords.includes("hours") || dateInWords.includes("day") ) && (new Date().getDate() - new Date(timestamp).getDate() === 1)) {
    relativeTime = `Yesterday at ${format(timestamp,'h:mm A')}`
  } else {
    relativeTime = `${format(timestamp, 'D MMM YYYY') } at ${format(timestamp,'h:mm A')}`
  }

  return relativeTime;

}

function getQuillDataContentLength(inputDeltaArray = []){
  return inputDeltaArray.reduce((accumulator, currElement) => {
    if(currElement.insert && currElement.attributes && currElement.attributes.link && !currElement.attributes.mention){
      return accumulator += currElement['insert'].length;
    }else if(currElement.insert && currElement.insert.image){
      return accumulator += 0;
    }else if(currElement.attributes && currElement.attributes.mention){
      return accumulator += currElement.attributes.mention.name.length;
    }else if(currElement.insert){
      return accumulator += currElement.insert.length;
    }
    return accumulator;
  }, 0);
}


function generateHTMLFromQuillData(opts = {}) {
  const initStructure = {
    contentLength : 0,
    html: ''
  };
  return opts.commentBodyOps.reduce((accumulator, currElement) => {
    if(opts.shortenComment && (accumulator['contentLength'] > (opts.truncateLength || 250))){
      return accumulator;
    }
    if(currElement.insert && currElement.attributes && currElement.attributes.link && !currElement.attributes.mention){
      accumulator['contentLength'] = accumulator['contentLength'] + currElement['insert'].length;
      accumulator['html'] = accumulator['html'] + `<a class="${opts.disableLink ? 'disable-link' : ''}" href="${currElement['attributes']['link']}" target="_blank">${currElement['insert']}</a>`;
    }else if(currElement.insert && currElement.insert.image){
      const imageUrl = `${currElement.insert.image}?q=60`;
      accumulator['html'] = accumulator['html'] +  `<div class="small-content-image"><img src="${imageUrl}" /></div>`;
    }else if(currElement.attributes && currElement.attributes.mention){
      accumulator['contentLength'] = accumulator['contentLength'] + currElement.attributes.mention.name.length;
      const link = currElement.attributes.link && (currElement.attributes.link !== 'javascript:void(0)') ? currElement.attributes.link : '#';
      const linkText = (currElement.attributes.mention.name !== 'undefined') ? currElement.attributes.mention.name : '@undefined';
      const target = (opts.source === 'widget') ? '_self' : '_blank';
      const linkAttr = (opts.source === 'widget') ? "javascript:void(0)" : `/profile/${link}`;
      accumulator['html'] = `${accumulator['html']}<a href="${linkAttr}" target="${target}" class="mention-name" data-slug="${link}">${(opts.shortenComment || false) ? linkText.substring(0, opts.truncateLength || 250) : linkText}</a>`;
    }else if(currElement.insert){
      const sanitizedHtml = sanitizer.sanitize(currElement.insert);
      accumulator['contentLength'] = accumulator['contentLength'] + currElement.insert.length;
      accumulator['html'] = accumulator['html'] +  ` ${(opts.shortenComment || false) ? sanitizedHtml.substring(0, opts.truncateLength || 250).replace(/\n/g, "<br />") : sanitizedHtml.replace(/\n/g, "<br />")} `;
    }
    return accumulator;
  }, initStructure);
}

function getDeviceTruncateLength(commentBodyViewPage) {
  if(commentBodyViewPage ==='commentsManagerPage') {
    return 160;
  }
  else if(commentBodyViewPage === 'commentDetailedViewPage') {
    return 0;
  }
  else if(commentBodyViewPage === 'commentsFeedPage' || (screen.width > 479 && screen.width < 770)) {
    return 300;
  }
  else if(screen.width > 319 && screen.width < 480 ) {
    return 200;
  }
  return 650;
}

function truncateString(inputString = '', desiredLength = 10) {
  if(isValidValue(inputString)) {
    if (inputString.length > desiredLength) {
      const omissionString = '...',
            truncateLength = (desiredLength -  (omissionString.length));
      return inputString.substring(0, truncateLength) + omissionString;
    } else {
      return inputString;
    }
  } else {
    return "";
  }
}

function setElementAttributesHelper(el, attrs) {
  for (const key in attrs) {
    el.setAttribute(key, attrs[key])
  }
}

function positionQuickView(leftPos) {
  let offsetLeft, offsetTop;
  if(screen.width > 420 && screen.width <= 768) {
    offsetLeft = leftPos;
    offsetTop = -100;
  }
  else if(screen.width > 768) {
    offsetLeft = (leftPos > 200) ? (leftPos - 150) : 150;
    offsetTop = (screen.width > 420) ? -185 : 0;
  }
  else {
    offsetLeft = leftPos - 50;
    offsetTop = 0;
  }
  document.getElementsByClassName('quick-view-wrapper')[0].style.cssText = `left:${offsetLeft}px; top: ${offsetTop}px`;
}

function getDateInFormat(timeStamp) {
  if (timeStamp) { return timeStamp.toString(); }
}

function isValidValue(value) {
  return !(value === undefined || value=== null || value === "")
}

const reactionSVGMapper = {
  0 : DefaultEmoji,
  3 : AxiomEmoji,
  4 : ActionsEmoji,
  5 : InsightEmoji,
  13 : thumbsDownEmoji,
  14 : thumbsUpEmoji
};

const statusParameter = {
  "approved": "approved",
  "deleted": "hidden_or_deleted",
  "trash": "hidden_or_deleted",
  "spam": "spam",
  "pending": "pending"
};

function getValueByParameter(parameterName) {
  var result = null,
      tmp = [];
  location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split(/=(.*)/);
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
  return result;
}

export { stringToBase64,
  isUrl,
  humanizeDate,
  statusParameter,
  getDeviceTruncateLength,
  setElementAttributesHelper,
  reactionSVGMapper,
  generateHTMLFromQuillData,
  getQuillDataContentLength,
  getParameterFromUrl,
  setImageSearchParams,
  getParams,
  actionCountLabel,
  getHost,
  getAttributeName,
  truncateString,
  positionQuickView,
  isValidValue,
  getDateInFormat,
  getValueByParameter,
  dateFormat,
  formatAMPM
}



// WEBPACK FOOTER //
// ./app/javascript/util/utils.js